/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Inheritedpaymentmethods2Inputs */

const en__field_inheritedpaymentmethods2 = /** @type {(inputs: _Field_Inheritedpaymentmethods2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`payment methods (inherited)`)
};

const de__field_inheritedpaymentmethods2 = /** @type {(inputs: _Field_Inheritedpaymentmethods2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlungsmethoden (abgeleitet)`)
};

/**
* | output |
* | --- |
* | "payment methods (inherited)" |
*
* @param {_Field_Inheritedpaymentmethods2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_inheritedpaymentmethods2 = /** @type {((inputs?: _Field_Inheritedpaymentmethods2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Inheritedpaymentmethods2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_inheritedpaymentmethods2(inputs)
	return de__field_inheritedpaymentmethods2(inputs)
});
export { _field_inheritedpaymentmethods2 as "_field_inheritedPaymentMethods" }